<template>
  <div id="app" class="app-content mb-4">
    <app-header></app-header>
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <div class="amej-title"><h1>Load Fund</h1></div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-10">
          <p class="lead-text text-center">
            Choose how you want to add money to your Amejpay wallet.
          </p>

          <!-- GLOBAL -->
          <h6 class="grp">Global</h6>
          <div class="row">
            <div class="col-12 col-md-6 mb-3" v-for="(g, i) in globalGateways" :key="'g' + i">
              <div class="gw-card" :class="g.enabled ? '' : 'is-soon'" @click="choose(g)">
                <div class="gw-icon"><span class="material-icons">{{ g.icon }}</span></div>
                <div class="gw-body">
                  <div class="gw-name">{{ g.name }}</div>
                  <div class="gw-desc">{{ g.description }}</div>
                </div>
                <span class="gw-soon" v-if="!g.enabled">Coming soon</span>
                <span class="material-icons gw-arrow" v-else>chevron_right</span>
              </div>
            </div>
          </div>

          <!-- LOCAL -->
          <h6 class="grp">
            Local
            <small class="muted" v-if="countryName"> &middot; {{ countryName }}</small>
          </h6>
          <div class="row" v-if="localGateways.length">
            <div class="col-12 col-md-6 mb-3" v-for="(g, i) in localGateways" :key="'l' + i">
              <div class="gw-card" :class="g.enabled ? '' : 'is-soon'" @click="choose(g)">
                <div class="gw-icon"><span class="material-icons">{{ g.icon }}</span></div>
                <div class="gw-body">
                  <div class="gw-name">{{ g.name }}</div>
                  <div class="gw-desc">{{ g.description }}</div>
                </div>
                <span class="gw-soon" v-if="!g.enabled">Coming soon</span>
                <span class="material-icons gw-arrow" v-else>chevron_right</span>
              </div>
            </div>
          </div>
          <div class="empty-box" v-else>
            No local payment method is available for your country yet.
            You can still add funds with a card.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import { mapActions, mapState } from "vuex";

/**
 * Local gateways per country. Adding one is a data change here plus its route —
 * the card flow already proves the payment/initiate contract.
 */
const LOCAL_GATEWAYS = {
  Nepal: [
    { key: "esewa", name: "eSewa", icon: "account_balance_wallet", description: "Pay with your eSewa wallet", enabled: false },
    { key: "khalti", name: "Khalti", icon: "account_balance_wallet", description: "Pay with your Khalti wallet", enabled: false },
  ],
  India: [
    { key: "phonepe", name: "PhonePe", icon: "smartphone", description: "Pay with PhonePe UPI", enabled: false },
    { key: "paytm", name: "Paytm", icon: "smartphone", description: "Pay with your Paytm wallet", enabled: false },
  ],
};

export default {
  name: "LoadFund",
  components: { "app-header": AppHeader },
  data() {
    return {
      globalGateways: [
        {
          key: "card",
          name: "Load from Card",
          icon: "credit_card",
          description: "Visa, Mastercard and more",
          enabled: true,
          route: "loadcard",
        },
      ],
    };
  },
  computed: {
    ...mapState(["profile"]),
    countryName: function () {
      const a = this.profile && this.profile.author;
      return (a && a.country) || "";
    },
    /** Matched case-insensitively so "nepal" and "Nepal" both resolve. */
    localGateways: function () {
      const c = String(this.countryName || "").trim().toLowerCase();
      if (!c) { return []; }
      const keys = Object.keys(LOCAL_GATEWAYS);
      for (let i = 0; i < keys.length; i++) {
        if (keys[i].toLowerCase() === c) { return LOCAL_GATEWAYS[keys[i]]; }
      }
      return [];
    },
  },
  created() {
    if (!this.profile || !this.profile.author) { this.listProfile(); }
  },
  methods: {
    ...mapActions(["listProfile"]),
    choose(g) {
      if (!g || !g.enabled || !g.route) { return; }
      this.$router.push({ name: g.route }).catch(function () {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../css/style.scss';

.lead-text { color: #6c757d; font-size: 14px; margin-bottom: 22px; }
.grp {
  font-size: 12px; text-transform: uppercase; letter-spacing: .5px; font-weight: 700;
  color: #6c757d; margin: 18px 0 10px; border-bottom: 1px solid #eef1f4; padding-bottom: 6px;
}
.muted { color: #9aa4ae; text-transform: none; letter-spacing: 0; font-weight: 600; }
.gw-card {
  display: flex; align-items: center; gap: 14px; cursor: pointer;
  background: #fff; border: 1px solid rgba(0,0,0,0.08); border-radius: 10px;
  padding: 16px 18px; height: 100%; transition: border-color .15s ease, box-shadow .15s ease;
}
.gw-card:hover { border-color: #0066b3; box-shadow: 0 2px 10px rgba(0,102,179,.08); }
.gw-card.is-soon { cursor: default; opacity: .65; }
.gw-card.is-soon:hover { border-color: rgba(0,0,0,0.08); box-shadow: none; }
.gw-icon {
  width: 44px; height: 44px; border-radius: 10px; background: #eef4fb;
  display: flex; align-items: center; justify-content: center; flex: 0 0 auto;
}
.gw-icon .material-icons { color: #0066b3; }
.gw-body { flex: 1; min-width: 0; }
.gw-name { font-weight: 600; font-size: 15px; }
.gw-desc { font-size: 12px; color: #6c757d; }
.gw-arrow { color: #b6c0ca; }
.gw-soon {
  font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .4px;
  background: #eef1f4; color: #6c757d; padding: 3px 8px; border-radius: 9px; white-space: nowrap;
}
.empty-box {
  background: #f7f9fa; border: 1px dashed #dfe3e8; border-radius: 8px;
  padding: 14px; color: #6c757d; font-size: 13px;
}
</style>
